'use client'

import React from 'react'

interface Props {
    targetId: string
    children: React.ReactNode
    className?: string
}

const ScrollToSectionButton = ({ targetId, children, className = '' }: Props) => {
    const handleClick = () => {
        document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    return (
        <button type="button" onClick={handleClick} className={className}>
            {children}
        </button>
    )
}

export default ScrollToSectionButton
